export const getCroppedDecimalPart = (value, limit) => {
  if (typeof value !== "number") return "";
  if (value % 1 === 0) return value;

  return value.toFixed(limit);
};
